import React from 'react';
import styled from 'styled-components';
import { Switch as AntSwitch } from 'antd';
import { Colors } from 'basic-ui-lib/constants';

export interface SwitchProps {
  value?: boolean;
  onChange?: (val: boolean) => void;
  style?: React.CSSProperties;
  disabled?: boolean;
  loading?: boolean;
}

const StyledSwitch = styled(AntSwitch)`
  &.ant-switch {
    width: 40px;
    min-width: 40px;
    height: 24px;
    padding: 0;
    border-radius: 16px;
    background: ${Colors.neutral.bg[7]};
    transition: background 0.2s ease;

    &:hover:not(.ant-switch-disabled) {
      background: ${Colors.neutral.bg[6]};
    }
  }

  &.ant-switch-checked {
    background: ${Colors.primary[5]};

    &:hover:not(.ant-switch-disabled) {
      background: ${Colors.primary[4]};
    }
  }

  .ant-switch-handle {
    width: 16px;
    height: 16px;
    inset-block-start: 4px;
    inset-inline-start: 4px;

    &::before {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: white;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
    }
  }

  .ant-switch-inner {
    display: none;
  }
`;

const Switch: React.FC<SwitchProps> = ({
  value = false,
  onChange,
  style,
  disabled,
  loading,
}) => {
  return (
    <StyledSwitch
      checked={value}
      onChange={onChange}
      disabled={disabled}
      loading={loading}
      style={style}
    />
  );
};

export default Switch;